import { render, staticRenderFns } from "./MarketingEmailList.vue?vue&type=template&id=70397c5b&scoped=true"
import script from "./MarketingEmailList.vue?vue&type=script&lang=js"
export * from "./MarketingEmailList.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailList.vue?vue&type=style&index=0&id=70397c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70397c5b",
  null
  
)

export default component.exports